import { Location } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FundHeaderService } from '@components/products/overview/services/fund-header.service';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { TitleService } from '@services/title.service';
import { Subscription } from 'rxjs';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'ft-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Input() page;
  breadcrumbs: any = [];
  isBreadcrumbShown = true;
  contentCheck = false;
  dataSubscription: Subscription;

  constructor(
    private titleService: TitleService,
    private location: Location,
    private breadcrumbService: BreadcrumbService,
    private fundHeaderService: FundHeaderService,
    private elementRef: ElementRef,
    private metaService: Meta
  ) {}

  ngOnInit(): void {
    const home = 'Home';
    if (this.isFundPage()) {
      this.dataSubscription = this.fundHeaderService
        .getFundHeaderState$()
        .subscribe((state) => {
          this.breadcrumbs = this.breadcrumbService.getBreadcrumbs(
            this.page,
            state.fundName
          );
          this.addSchema();
        });
    } else {
      this.breadcrumbs = this.breadcrumbService.getBreadcrumbs(this.page);
      this.addSchema();
    }

    this.isBreadcrumbShown = !this.page?.getComponent().getModels()?.pageData
      ?.hideBreadcrumbs;

    // Meta title
    const pageData = this.page?.getComponent().getModels()?.pageData;
    if (!pageData?.metaTitle) {
      if (this.location.path().indexOf('about-us') > 0) {
        this.titleService.setTitle('About Us');
        this.metaService.updateTag(
          {
            property: 'og:title',
            content: 'About Us',
          },
          "property='og:title'"
        );
      } else {
        const lastElement = this.breadcrumbs?.length
          ? this.breadcrumbs[this.breadcrumbs?.length - 1]
          : home;
        const metaTitle = lastElement.name;
        if (metaTitle && !this.isFundPage()) {
          this.titleService.setTitle(metaTitle);
        }
      }
    }
  }

  isFundPage(): boolean {
    return this.page?.getUrl()?.startsWith('/fund-details');
  }

  ngOnDestroy(): void {
    // Unsubscribe fundHeaderService subscriber.
    this.dataSubscription?.unsubscribe();
  }

  private addSchema() {
    const urlRoot = 'https://www.franklintempletonindia.com';
    const breadcrumbs = this.breadcrumbs?.map((breadcrumb, i) => ({
      '@type': 'ListItem',
      position: i + 2,
      item: {
        '@id': breadcrumb.link ? urlRoot + breadcrumb.link : '',
        name: breadcrumb.name,
      },
    }));
    const schema = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          position: 1,
          item: {
            '@id': urlRoot,
            name: 'Home',
          },
        },
        ...(breadcrumbs ? breadcrumbs : []),
      ],
    };

    // set url of leaf
    schema.itemListElement[schema.itemListElement.length - 1].item['@id'] =
      urlRoot + this.page?.getUrl().replace(/\/_index_$/, '');

    // add to page
    const s = document?.createElement('script');
    s.type = 'application/ld+json';
    s.innerText = JSON.stringify(schema);
    this.elementRef.nativeElement.appendChild(s);
  }
}
